import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { clearFilter } from "../components/Withdrawals/filterConfig";
import apiClient from "../utils/api/apiClient";
import { APIEndpoints } from "../utils/api/apiConfig";
import { PenIcon } from "../components/Icons/PenIcon";
import { StoreIcon } from "../components/Icons/StoreIcon";
import { DeleteIcon } from '../components/Icons/DeleteIcon'
import { makeCall } from '../utils/api/makeCall'
import { isEmptyGuid } from '../utils/emptyGuid'
import axios from "axios";
import useReport from '../utils/hooks/useReport'
import { getErrorMessageFromApiResponse, setPointerErrorsFromApiResponse } from "../utils/api/apiUtils"

//import { BiUndo, BiRecycle, BiRefresh } from "react-icons/bi";
import { BsBuildingFillGear, BsFillExclamationCircleFill, BsRewindCircleFill, BsFillPrinterFill, BsFillLockFill } from "react-icons/bs";

const CancelToken = axios.CancelToken;
let cancel;

const WithdrawalsContext = React.createContext({});
export function useWithdrawalsState() {
    return React.useContext(WithdrawalsContext);
}
const initialFilter = {
    "filter.shippingNo": "",
    "filter.orderNo": "",
    "filter.receiptName": "",
    "filter.storehouseCoordinatesOrName": "",
    "filter.officeDisplayName": "",
    "filter.costCenterDisplayName": "",
    "filter.orderTypeDisplayName": "",
    "filter.excludeNoPositionHasReservations": "",
    "filter.excludePartiallyReserved": "",
    "filter.excludePickingProcessStarted": "",
    "filter.excludeReadyForShipment": "",
    "filter.excludePartiallyPicked": "",
    "filter.includeIsCompletyShipped": "",
    "filter.includeHasBeenPicked": "",
};
const initialPickingProcessFilter = {
    includeNoPositionHasReservations: true,
    includePartiallyReserved: true,
    includePickingProcessStarted: true,
    includeReadyForShipment: true,
    includePartialPicked: true,
    includeIsCompletyShipped: false,
    includeHasBeenPicked: false,
};
const WithdrawalsProvider = ({ children }) => {
    const [/*errorStates*/, setErrorStates] = useState({})
    const [/*loadingStates*/, setLoadingStates] = useState({})
    const [loaded, setLoaded] = useState(false);
    const [pageOffset, setPageOffset] = useState(0);
    const [pageLimit, setPageLimit] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [showAllWithdrawals, setShowAllWithdrawals] = useState(false);
    const [filter, setFilter] = useState(initialFilter);
    const [sorting, setSorting] = useState("orderCreatedAt");
    const [selectedRow, setSelectedRow] = useState(false);
    const [withdrawals, setWithdrawals] = useState([]);
    const [tableIsLoading, setTableIsLoading] = useState(false);
    const [showOverlayLeft, setShowOverlayLeft] = useState(false);
    const [forceReloadWithdrawals, setForceReloadWithdrawals] =
        useState(false);
    const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
    const [allCheckBoxesSelected, setAllCheckBoxesSelected] = useState(false);
    const [allSelectedLoading, setAllSelectedLoading] = useState(false);
    const [initialTableId, setInitialTableId] = useState(null);
    const [pickingProcessFilter, setPickingProcessFilter] = useState(initialPickingProcessFilter);

    const [openPickingProcessFilter, setOpenPickingProcessFilter] = useState(false);
    const [storehouseFilter, setStorehouseFilter] = useState(null);
    const [openStorehouseFilter, setOpenStorehouseFilter] = useState(false);
    const [orderProcessTypeFilter, setOrderProcessTypeFilter] = useState(null);
    const [openOrderProcessTypeFilter, setOpenOrderProcessTypeFilter] = useState(false);

    const [openDateRangeFilter, setOpenDateRangeFilter] = useState(false);
    const [startDateFilter, setStartDateFilter] = useState(null);
    const [endDateFilter, setEndDateFilter] = useState(null);
    const [selectedSOId, setSelectedSOId] = useState(null);
    const [changeSourceStorehouse, setChangeSourceStorehouse] = useState(null);
    const [deleteSO, setDeleteSO] = useState(null);
    const [resetSO, setResetSO] = useState(null);
    const [unLockSO, setUnLockSO] = useState(null);
    const { createReport, /*reportIsLoading*/ } = useReport()

    const [openOfficeFilter, setOpenOfficeFilter] = useState(false)
    const [openCostCenterFilter, setOpenCostCenterFilter] = useState(false)
    const [officeFilter, setOfficeFilter] = useState('')
    const [officeName, setOfficeName] = useState('')
    const [costCenterFilter, setCostCenterFilter] = useState('')
    const [costCenterName, setCostCenterName] = useState('')
    const { t } = useTranslation();
    const [lastParams, setLastParams] = useState(
        JSON.stringify({
            pageOffset,
            pageLimit,
            filter,
            showAllWithdrawals,
            sorting,
        })
    );
    const [filterSOHeader, setFilterSOHeader] = useState(null);
    const resetFilter = (test = null) => {
        clearFilter();
        setFilter(initialFilter);
        setOrderProcessTypeFilter(null);
        setStorehouseFilter(null);
        setStartDateFilter(null);
        setEndDateFilter(null);
        setPickingProcessFilter(initialPickingProcessFilter)
        if (!showAllWithdrawals) {
            setWithdrawals([]);
            setTotalCount(0);
        }
    };
    //when closing OverlayLeft
    const updateOverlayLeftStates = () => {
        officeFilter ? setOpenOfficeFilter(true) : setOpenOfficeFilter(false)
        costCenterFilter ? setOpenCostCenterFilter(true) : setOpenCostCenterFilter(false)
        orderProcessTypeFilter ? setOpenOrderProcessTypeFilter(true) : setOpenOrderProcessTypeFilter(false);
        pickingProcessFilter ? setOpenPickingProcessFilter(true) : setOpenPickingProcessFilter(false);
        storehouseFilter
            ? setOpenStorehouseFilter(true)
            : setOpenStorehouseFilter(false);
        startDateFilter || endDateFilter
            ? setOpenDateRangeFilter(true)
            : setOpenDateRangeFilter(false);
    };
    useEffect(() => {
        setFilter(prev => ({ ...prev, 'filter.costCenterIds': costCenterFilter || '' }))
    }, [costCenterFilter])

    useEffect(() => {
        setFilter(prev => ({ ...prev, 'filter.officeIds': officeFilter || '' }))
    }, [officeFilter])
    useEffect(() => {
        setFilter((prev) => ({
            ...prev,
            "filter.storehouseId": storehouseFilter?.storehouseId || "",
        }));
    }, [storehouseFilter]);
    useEffect(() => {
        setFilter((prev) => ({
            ...prev,
            "filter.ordertypeId": orderProcessTypeFilter?.orderProcessTypeId || "",
        }));
    }, [orderProcessTypeFilter]);
    useEffect(() => {
        setFilter((prev) => ({
            ...prev,
            "filter.startDate": startDateFilter || "",
        }));
    }, [startDateFilter]);
    useEffect(() => {
        setFilter((prev) => ({ ...prev, "filter.endDate": endDateFilter || "" }));
    }, [endDateFilter]);
    useEffect(() => {
        if (!pickingProcessFilter?.includeNoPositionHasReservations && !pickingProcessFilter?.includePartiallyReserved
            && !pickingProcessFilter?.includePickingProcessStarted && !pickingProcessFilter?.includeReadyForShipment && !pickingProcessFilter?.includePartialPicked
            && !pickingProcessFilter?.includeIsCompletyShipped && !pickingProcessFilter?.includeHasBeenPicked) {
            setPickingProcessFilter(initialPickingProcessFilter)
            setForceReloadWithdrawals(true)
        }
    }, [pickingProcessFilter]);
    useEffect(() => {
        setFilter((prev) => ({
            ...prev,
            "filter.excludeNoPositionHasReservations": !pickingProcessFilter?.includeNoPositionHasReservations ? "true" : "",
            "filter.excludePartiallyReserved": !pickingProcessFilter?.includePartiallyReserved ? "true" : "",
            "filter.excludePickingProcessStarted": !pickingProcessFilter?.includePickingProcessStarted ? "true" : "",
            "filter.excludeReadyForShipment": !pickingProcessFilter?.includeReadyForShipment ? "true" : "",
            "filter.excludePartiallyPicked": !pickingProcessFilter?.includePartialPicked ? "true" : "",
            "filter.includeIsCompletyShipped": !!pickingProcessFilter?.includeIsCompletyShipped ? "true" : "",
            "filter.includeHasBeenPicked": !!pickingProcessFilter?.includeHasBeenPicked ? "true" : "",
        }));
    }, [pickingProcessFilter]);
    const handleLocalChangeCheckbox = (id) => {
        if (allCheckBoxesSelected) {
            setAllCheckBoxesSelected(false);
        }
        if (selectedCheckBoxes.includes(id)) {
            var index = selectedCheckBoxes.indexOf(id);
            var newValues = [...selectedCheckBoxes];
            newValues.splice(index, 1);
            setSelectedCheckBoxes(newValues);
        } else {
            setSelectedCheckBoxes((prev) => [...prev, id]);
        }
    };

    //cancel previous calls that are still pending if existing
    const cancelPrevious = () => {
        cancel && cancel();
    };

    const loadWithdrawals = async () => {
        cancelPrevious();
        const cancelToken = new CancelToken(function executor(c) {
            cancel = c;
        });
        try {
            let params = getParams();
            const response = await apiClient.getJson(
                APIEndpoints.withdrawals().search,
                params,
                true,
                true,
                true,
                { cancelToken }
            );
            if (response.headers["x-total-count"]) {
                setTotalCount(Number(response.headers["x-total-count"]));
            } else {
                setTotalCount(0);
            }
            return response.data;
        } catch (e) {
            if (axios.isCancel(e)) {
                console.log("cancelled by cancelToken");
            }
            return null;
        }
    };

    const getParams = () => {
        const filterWithValues = { ...filter };
        Object.keys(filterWithValues).forEach((filterName) => {
            if (filterWithValues[filterName] === "") {
                delete filterWithValues[filterName];
            }
        });
        let params = { ...filterWithValues };
        params["page.offset"] = pageOffset;
        params["page.limit"] = pageLimit;
        if (sorting) {
            params["sort"] = sorting;
        }
        return params;
    };
    const allowDeleteSO = (item) => {
        if (itemIsLocked(item)) return false;
        if (item.status === 'pickingProcessStarted' || item.status === 'partiallyPicked' || item.status === 'hasBeenPicked' || item.status === 'isCompletelyShipped') return false
        return !item.isBlockedForDeletion
    }
    const allowResetSO = (item) => {
        if (itemIsLocked(item)) return false;
        return item.status === 'pickingProcessStarted'
    }
    const allowChangeSO = (item) => {
        if (itemIsLocked(item)) return false;
        if (item.status === 'pickingProcessStarted' || item.status === 'partiallyPicked' || item.status === 'hasBeenPicked' || item.status === 'isCompletelyShipped') return false
        return true
    }
    const allowPickingControl = (item) => {
        if (itemIsLocked(item)) return false;
        if (item.status === 'pickingProcessStarted' || item.status === 'partiallyPicked') return true
        return false
    }
    const allowPrintPickinglist = (item) => {
        if (itemIsLocked(item)) return false;
        if (item.status === 'pickingProcessStarted' || item.status === 'partiallyPicked' || item.status === 'readyForShipment') return true
        return false
    }
    const allowPrintPackagelabel = (item) => {
        if (itemIsLocked(item)) return false;
        if (item.status === 'hasBeenPicked' || item.status === 'isCompletelyShipped') return true
        return false
    }
    const itemIsLocked = (item) => {
        if (item.lockInfo && !item.lockInfo?.lockedByUser) return true
        return false
    }
    const getLockedTitle = (item) => {
        if (item.lockInfo && !!item.lockInfo?.lockedByUser) return t('withdrawalsTable:unlock')
        return `${t('withdrawalsTable:lockedBy')} ${item.lockInfo?.creator?.displayName}`
    }
    const appendData = (data) => {
        return data.map((item) => ({
            ...item,
            actions: (
                <span>
                    {item.lockInfo &&
                        <span>
                            <Link
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedSOId(item.id);
                                    setUnLockSO(true);
                                }}
                                title={getLockedTitle(item)}
                            >
                                <BsFillLockFill color="#000000" />
                            </Link>
                        </span>}
                    {!itemIsLocked(item) && !item.orderWasCreatedInSubmandator &&
                        <span>
                            <Link
                                to={`/orders/${item.orderId}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                title={t("withdrawalsTable:orderInfo")}
                            >
                                <BsFillExclamationCircleFill color="#000000" />
                            </Link>
                        </span>}
                    {allowChangeSO(item) &&
                        <span>
                            <Link
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedSOId(item.id);
                                    setChangeSourceStorehouse(true);
                                }}
                                title={t("withdrawalsTable:changeStorehouse")}
                            >
                                <BsBuildingFillGear color="#000000" />
                            </Link>
                        </span>}
                    {allowChangeSO(item) && <span>
                        <Link
                            to={`/localstorage/withdrawals/${item.id}/pickprep`}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            title={t("withdrawalsTable:partialPicking")}
                        >
                            <PenIcon color="#000000" />
                        </Link>
                    </span>}
                    {allowPickingControl(item) && <span>
                        <Link
                            to={`/localstorage/withdrawals/${item.id}/pickcont`}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            title={t("withdrawalsTable:pickingControl")}
                        >
                            <StoreIcon color="#000000" />
                        </Link>
                    </span>}
                    {allowResetSO(item) &&
                        <span>
                            <Link
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedSOId(item.id);
                                    setResetSO(true)
                                }}
                                title={t("withdrawalsTable:resetPickingProcess")}
                            >
                                <BsRewindCircleFill color="#000000" />
                            </Link>
                        </span>}
                    {allowPrintPickinglist(item) &&
                        <span>
                            <Link
                                onClick={(e) => {
                                    e.stopPropagation();
                                    printPickinglist(item.id);
                                }}
                                title={t("withdrawalsTable:printPickinglist")}
                            >
                                <BsFillPrinterFill color="#000000" />
                            </Link>
                        </span>}
                    {allowPrintPackagelabel(item) &&
                        <span>
                            <Link
                                onClick={(e) => {
                                    e.stopPropagation();
                                    printPackagelabel(item.id);
                                }}
                                title={t("withdrawalsTable:printPackagelabel")}
                            >
                                <BsFillPrinterFill color="#000000" />
                            </Link>
                        </span>}
                    {allowDeleteSO(item) &&
                        <span>
                            <Link
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedSOId(item.id);
                                    setDeleteSO(true);
                                }}
                                title={t("delete")}
                            >
                                <DeleteIcon color="#000000" />
                            </Link>
                        </span>}
                </span>
            ),
            checkBox: (
                <span>
                    <input
                        type="checkbox"
                        id={item.id}
                        name="scales"
                        checked={selectedCheckBoxes.includes(item.id)}
                        onChange={() => { }}
                    ></input>
                </span>
            ),
        }));
    };

    useEffect(() => {
        const newParams = JSON.stringify({
            pageOffset,
            pageLimit,
            filter,
            showAllWithdrawals,
            sorting,
        });
        const filtersHaveChanged =
            JSON.stringify(filter) !== JSON.stringify(JSON.parse(lastParams).filter);
        const sortingHasChanged =
            JSON.stringify(sorting) !==
            JSON.stringify(JSON.parse(lastParams).sorting);
        //go to page 1 if filter or sorting have changed
        if (pageOffset !== 0 && (sortingHasChanged || filtersHaveChanged)) {
            var newParamsFilter = JSON.parse(lastParams);
            newParamsFilter.filter = filter;
            newParamsFilter.sorting = sorting;
            setLastParams(JSON.stringify(newParamsFilter));
            setPageOffset(0);
        } else if (lastParams !== newParams || forceReloadWithdrawals) {
            setForceReloadWithdrawals(false);
            setLastParams(newParams);
            (async () => {
                if (
                    showAllWithdrawals ||
                    Object.keys(filter).reduce(
                        (acc, item) => acc || filter[item] !== "",
                        false
                    )
                ) {
                    setTableIsLoading(true);
                    const result = await loadWithdrawals();
                    if (result) {
                        // add action icons
                        let preparedResult = appendData(result);
                        setWithdrawals(preparedResult);
                        setTableIsLoading(false);
                    }
                } else {
                    cancelPrevious();
                    setWithdrawals([]);
                    setTotalCount(0);
                    setTableIsLoading(false);
                }
                if (filtersHaveChanged) {
                    //setSelectedCheckBoxes([])
                    setAllCheckBoxesSelected(false);
                }
            })();
        }
        //eslint-disable-next-line
    }, [
        pageOffset,
        pageLimit,
        filter,
        showAllWithdrawals,
        sorting,
        forceReloadWithdrawals,
        setForceReloadWithdrawals,
    ]);

    const selectAll = () => {
        if (allCheckBoxesSelected || withdrawals.length < 1) {
            setAllCheckBoxesSelected(false);
            setSelectedCheckBoxes([]);
        } else {
            setAllSelectedLoading(true);
            const filterWithValues = { ...filter };
            Object.keys(filterWithValues).forEach((filterName) => {
                if (filterWithValues[filterName] === "") {
                    delete filterWithValues[filterName];
                }
            });
            apiClient
                .getJson(APIEndpoints.withdrawals().search, {
                    ...filterWithValues,
                })
                .then((result) => {
                    if (result) {
                        const arrayOfAllIds = result.map((obj) => obj.id);
                        setSelectedCheckBoxes(arrayOfAllIds);
                    }
                })
                .finally(() => {
                    setAllCheckBoxesSelected(true);
                    setAllSelectedLoading(false);
                });
        }
    };

    useEffect(() => {
        // add action icons
        // todo only change selected one
        setWithdrawals((prev) =>
            prev.map((item) => ({
                ...item,
                checkBox: (
                    <span>
                        <input
                            type="checkbox"
                            id={item.id}
                            name="scales"
                            checked={selectedCheckBoxes.includes(item.id)}
                            onChange={() => { }}
                        ></input>
                    </span>
                ),
            }))
        );
    }, [selectedCheckBoxes]);
    
    const lockShippingOrder = async (soId) => {
        if (!isEmptyGuid(soId)) {
            setTableIsLoading(true)
            await makeCall('lockShippingOrder', async () => {
                await apiClient.postJson(APIEndpoints.withdrawals(soId).lockShippingOrder)
            }, setErrorStates, setLoadingStates)
            setTableIsLoading(false)
            setForceReloadWithdrawals(true)
        }
    }
    const unlockShippingOrder = async (soId) => {
        if (!isEmptyGuid(soId)) {
            setTableIsLoading(true)
            await makeCall('unlockShippingOrder', async () => {
                await apiClient.postJson(APIEndpoints.withdrawals(soId).unlockShippingOrder)
            }, setErrorStates, setLoadingStates)
            setTableIsLoading(false)
            setForceReloadWithdrawals(true)
        }
    }
    const stealLockShippingOrder = async (soId) => {
        if (!isEmptyGuid(soId)) {
            setTableIsLoading(true)
            await makeCall('stealLockShippingOrder', async () => {
                await apiClient.postJson(APIEndpoints.withdrawals(soId).stealLockShippingOrder)
            }, setErrorStates, setLoadingStates)
            setTableIsLoading(false)
            setForceReloadWithdrawals(true)
        }
    }
    const deleteShippingOrder = async () => {
        if (!isEmptyGuid(selectedSOId)) {
            setTableIsLoading(true)
            await makeCall('deleteShippingOrder', async () => {
                await apiClient.deleteJson(APIEndpoints.withdrawals(selectedSOId).shippingOrders)
            }, setErrorStates, setLoadingStates)
            setTableIsLoading(false)
            setForceReloadWithdrawals(true)
        }
        setSelectedSOId(null)
        setDeleteSO(null)

    }
    const resetShippingOrder = async () => {
        if (!isEmptyGuid(selectedSOId)) {
            setTableIsLoading(true)
            await makeCall('resetShippingOrder', async () => {
                await apiClient.postJson(APIEndpoints.withdrawals(selectedSOId).resetShippingOrders)
            }, setErrorStates, setLoadingStates)
            setTableIsLoading(false)
            setForceReloadWithdrawals(true)
        }
        setSelectedSOId(null)
        setResetSO(null)
    }
    const printPickinglist = async (soId) => {
        if (!isEmptyGuid(soId)) {
            setTableIsLoading(true)
            try {
                await apiClient.postJson(APIEndpoints.withdrawals(soId).pickingStarted)
                createReport('printPickinglist', APIEndpoints.withdrawals(soId).printPickinglist, {})
            }
            catch (e) {
                console.log(getErrorMessageFromApiResponse(e))
                console.log(setPointerErrorsFromApiResponse(e))
            }
            setTableIsLoading(false)
            setForceReloadWithdrawals(true)
        }
    }
    const printPackagelabel = async (soId) => {
        if (!isEmptyGuid(soId)) {
            setTableIsLoading(true)
            try {
                createReport('printPackagelabel', APIEndpoints.withdrawals(soId).printPackagelabel, {})
            }
            catch (e) {
                console.log(getErrorMessageFromApiResponse(e))
                console.log(setPointerErrorsFromApiResponse(e))
            }
            setTableIsLoading(false)
        }
    }
    const getShippingOrder = (shippingOrderId) => {
        let shippingOrder = withdrawals.find(item => item.id === shippingOrderId)
        return shippingOrder
    }
    const getSourceStorehouseId = (shippingOrderId) => {
        let shippingOrder = getShippingOrder(shippingOrderId)
        return shippingOrder?.sourceStorehouse?.id ?? null
    }
    const contextValues = {
        setSelectedCheckBoxes,
        allCheckBoxesSelected,
        selectAll,
        allSelectedLoading,
        selectedCheckBoxes,
        handleLocalChangeCheckbox,
        loaded,
        setLoaded,
        pageOffset,
        setPageOffset,
        pageLimit,
        setPageLimit,
        totalCount,
        setTotalCount,
        showAllWithdrawals,
        setShowAllWithdrawals,
        filter,
        setFilter,
        withdrawals,
        setWithdrawals,
        selectedRow,
        setSelectedRow,
        sorting,
        setSorting,
        resetFilter,
        tableIsLoading,
        showOverlayLeft,
        setShowOverlayLeft,
        forceReloadWithdrawals,
        setForceReloadWithdrawals,
        initialTableId,
        setInitialTableId,
        updateOverlayLeftStates,
        storehouseFilter,
        setStorehouseFilter,
        openStorehouseFilter,
        setOpenStorehouseFilter,
        openDateRangeFilter,
        setOpenDateRangeFilter,
        startDateFilter,
        setStartDateFilter,
        endDateFilter,
        setEndDateFilter,
        filterSOHeader,
        setFilterSOHeader,
        openOfficeFilter,
        setOpenOfficeFilter,
        openCostCenterFilter,
        setOpenCostCenterFilter,
        officeName,
        setOfficeName,
        costCenterName,
        setCostCenterName,
        costCenterFilter,
        setCostCenterFilter,
        officeFilter,
        setOfficeFilter,
        pickingProcessFilter, setPickingProcessFilter, openPickingProcessFilter, setOpenPickingProcessFilter,
        openOrderProcessTypeFilter, setOpenOrderProcessTypeFilter, orderProcessTypeFilter, setOrderProcessTypeFilter,
        setSelectedSOId, setChangeSourceStorehouse, setDeleteSO, selectedSOId, changeSourceStorehouse, deleteSO, deleteShippingOrder,
        lockShippingOrder, unlockShippingOrder, stealLockShippingOrder, printPickinglist,
        resetSO, setResetSO, resetShippingOrder, getSourceStorehouseId, unLockSO, setUnLockSO, getShippingOrder
    };
    return (
        <WithdrawalsContext.Provider value={contextValues}>
            {children}
        </WithdrawalsContext.Provider>
    );
};

export default WithdrawalsProvider;
